import { format, parse } from 'date-fns'

export function releasedAtStatusText(releasedAt: string | null) {
	return !!releasedAt
		? `Released on ${format(parse(releasedAt, `yyyy-MM-dd'T'HH:mm:ss.SSSxxx`, new Date()), 'MM/dd/yyyy')}`
		: 'Disabled'
}
